<template>
  <template v-if="['new', 'pending', 'requested'].includes(getCurrentReport.status)">
    <div class="flex flex-col items-center md:w-2/3 mx-auto py-5 px-3">
      <img src="@/assets/images/truck-illustration.svg" class="py-3" />
      <h2 class="py-2">
        Your {{ getCurrentReport.short_label }} Report has been ordered and is being processed
      </h2>
      <template v-if="getCurrentReport.report_type === 'identity'">
        <p class="py-2">
          We have contacted the applicant via email with a link to complete their ID Verification.
          This link is live for 48 hours, and can only be used once.
        </p>

        <p class="py-2">
          As soon as the applicant completes the verification, the report will be available to view
          here!
        </p>

        <p class="py-2">
          If it's been over 48 hours, you can reach out to
          <a href="mailto:support@rentapplication.net" class="text-brand-green"
            >support@rentapplication.net</a
          >
          for further assistance.
        </p>
      </template>
      <template v-else>
        <p class="py-2">
          This report is currently being processed and should typically appear in less than 5
          minutes. You can try refreshing the page.
        </p>
        <template v-if="['eviction', 'criminal'].includes(getCurrentReport.report_type)">
          <p class="py-2">
            Occasionally, our processors need to manually review a report before it can be
            completed. This is usually due to common names or other identifying information
            returning items that may not be related to the applicant. In these cases, report
            processing can be delayed.
          </p>

          <p class="py-2">
            If this report is pending for more than 1 hour during business hours, please let us
            know. If it is still pending during non-business hours, it will typically resolve first
            thing when business hours resume.
          </p>
        </template>
      </template>
    </div>
  </template>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["getCurrentReport"])
  }
}
</script>
